import axios from 'axios';
import { API_BASE_URL } from '../constants/endpointConstants';
import { REFRESH_TOKEN_KEY, TOKEN_SESSION_KEY } from '../constants/commonConstants';
import { customStorage } from './UtilityService';
import { doRefreshToken } from './AuthService';

let sessionTimeoutLogout = () => { }; // <-- Placeholder
let sessionLogout = () => { }; // <-- Placeholder
let appContextToken = () => { };

export const setSessionTimeoutHandler = (callback) => {
    sessionTimeoutLogout = callback;
};
export const setSessionLogout = (callback) => {
    sessionLogout = callback;
};

export const setAppContextToken = (callback) => {
    appContextToken = callback;
};

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor to add the token to requests
api.interceptors.request.use((config) => {
    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    if (token) {
        const accessToken = token;
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
});

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(newToken) {
    refreshSubscribers.forEach(callback => callback(newToken));
    refreshSubscribers = [];
}

function addRefreshSubscriber(callback) {
    refreshSubscribers.push(callback);
}

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.log('api error', error);
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            const sessionRefreshToken = customStorage.getItem(REFRESH_TOKEN_KEY);

            if (!sessionRefreshToken) {
                sessionLogout();
                return Promise.reject(error);
            }

            if (isRefreshing) {
                // console.log('1111111111111111111111')
                return new Promise((resolve, reject) => {
                    addRefreshSubscriber((newToken) => {
                        // console.log("22222222222222222222222222")
                        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                        resolve(api(originalRequest));
                        isRefreshing=false;
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                // console.log("3333333333333333333333333")
                const newToken = await doRefreshToken();
                const { accessToken, refreshToken } = newToken;

                // console.log("Refreshing Token.......", isRefreshing, "token", newToken, "subscribers", refreshSubscribers);

                if (!accessToken) {
                    // console.log("44444444444444444444444444444")
                    sessionTimeoutLogout();
                    isRefreshing = false;
                    return Promise.reject(error);
                }

                if (!!accessToken) {
                    customStorage.setItem(TOKEN_SESSION_KEY, accessToken);
                    appContextToken(accessToken);
                }
                if (!!refreshToken) {
                    customStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
                }
                // console.log("55555555555555555555555555")
                onRefreshed(accessToken);
                isRefreshing = false;
                // console.log("6666666666666666666666")
                originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
                return api(originalRequest);

            } catch (refreshError) {
                console.error("Token refresh failed!", refreshError);
                isRefreshing = false;
                sessionLogout();
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;